module.exports = __webpack_public_path__ + "img/05.55c5621a.jpg";